import { axiosInstance } from "../axiosConfig.ts";
import {
  ICheckActivePaymentResponse,
  ICheckPaymentStatusResponse,
  IMakePaymentResponse,
  PaymentDestinationType,
} from "./types.ts";

export const paymentsAPI = {
  makePayment: async (
    {
      productId,
      amount,
      paymentDestination,
    }: {
      productId: string;
      amount: string;
      paymentDestination?: PaymentDestinationType;
    }): Promise<IMakePaymentResponse> => {
    const response = await axiosInstance.post<IMakePaymentResponse>(
      "/v1/rebill-sale",
      { productId, amount, paymentDestination },
    );

    return response.data;
  },

  checkPaymentStatus: async (id: string): Promise<ICheckPaymentStatusResponse> => {
    const response
        = await axiosInstance.get<ICheckPaymentStatusResponse>(`/v1/rebill-sale/applications/${id}/status`);

    return response.data;
  },

  checkActivePayment: async (): Promise<ICheckActivePaymentResponse> => {
    const response = await axiosInstance.get<ICheckActivePaymentResponse>(
      "/v1/rebill-sale/info",
    );

    return response.data;
  },
};
